import { useState } from 'react';
import { BillingAddressIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import { useDispatch } from '../../../../../store/store';
import { setEditCardModal } from '../../../../../store/workspace/slice';

export default function EditCard() {
    const dispatch = useDispatch();
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [fullName, setFullName] = useState('');
    const [billingAddress, setBillingAddress] = useState('');

    const confirm = () => {

    };

    return (
        <Modal
            size='sm'
            childClassName={styles.wrapper}
            title='Change Billing address'
            icon={<BillingAddressIcon />}
            closeFunc={() => dispatch(setEditCardModal(false))}
        >
            <Input
                label=' Full Name'
                placeholder=''
                type='text'
                value={fullName}
                onChange={setFullName}
            />
            <Input
                label='Billing Address'
                placeholder=''
                type='text'
                value={billingAddress}
                onChange={setBillingAddress}
            />
            <div className={styles.city_and_zip}>
                <Input
                    label='City'
                    placeholder=''
                    type='text'
                    value={city}
                    onChange={setCity}
                />
                <Input
                    label='Zip Code'
                    placeholder=''
                    type='text'
                    value={zipCode}
                    onChange={setZipCode}
                />
            </div>
            <Input
                label='Country'
                placeholder=''
                type='text'
                value={country}
                onChange={setCountry}
            />
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setEditCardModal(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    disabled={false}
                    onClick={confirm}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
};
